import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import type { CommonError } from 'CommonError-Types';

import { clearCommonError, setCommonError, setIsUIImplementationError } from './actions';

export const commonError = createReducer({} as CommonError)
  .handleAction(setCommonError, (_state, action) => action.payload)
  .handleAction(clearCommonError, () => ({}));

export const isUIImplementationError = createReducer(false).handleAction(
  setIsUIImplementationError,
  (_state, action) => action.payload,
);

const commonErrorReducer = combineReducers({
  commonError,
  isUIImplementationError,
});

export default commonErrorReducer;
export type CommonErrorState = ReturnType<typeof commonErrorReducer>;
